import React from 'react'
import { BasicStatsItem } from '../index.styles'

const WageFund = () => {
  const link = 'https://app.powerbi.com/view?r=eyJrIjoiYzZhZTUzNDMtMTNjMS00ZDBlLWEzMzgtOWZhMGJiYWM2MTNkIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9'
  return (
    <BasicStatsItem
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        flex: '1',
        minHeight: 'calc(100vh - 4.4rem)'
      }}>
      <iframe title="wage-fund iframe" src={link} />
    </BasicStatsItem>
  )
}

export default WageFund